// Use the lightweight browser build recommended by Algolia v5
import { liteClient as algoliasearch } from 'algoliasearch/lite';

export const ALGOLIA_CONFIG = {
  ALGOLIA_APP_ID: process.env.NEXT_PUBLIC_ALGOLIA_APP_ID as string,
  ALGOLIA_SEARCH_API_KEY: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY as string,
  INSTANT_SEARCH_INDEX_NAME: 'Products',
  INSTANT_SEARCH_QUERY_SUGGESTIONS: 'SearchAll_query_suggestions',
  LIST_INSTANT_SEARCH_INDEX: {
    SearchAll: 'SearchAll',
    SearchAllProducts: 'SearchAll_Products', // For search all page with products only
    Products: 'Products', // For products list page only
    Documents: 'Documents', // For documents list page and search all with documents only
    Articles: 'Articles', // For articles list page and search all with articles only
    StoreLocator: 'Stores',
  },
  LIST_INSTANT_SEARCH_QUERY_SUGGESTIONS: {
    Products: 'Products_query_suggestions',
    Documents: 'Documents_query_suggestions',
    Articles: 'Articles_query_suggestions',
  },
};

export const createSearchClient = () => {
  if (!ALGOLIA_CONFIG.ALGOLIA_APP_ID || !ALGOLIA_CONFIG.ALGOLIA_SEARCH_API_KEY) {
    throw new Error('Algolia credentials are not set');
  }
  return algoliasearch(ALGOLIA_CONFIG.ALGOLIA_APP_ID, ALGOLIA_CONFIG.ALGOLIA_SEARCH_API_KEY);
};

const hasAlgoliaCredentials = Boolean(ALGOLIA_CONFIG.ALGOLIA_APP_ID && ALGOLIA_CONFIG.ALGOLIA_SEARCH_API_KEY);

// Avoid throwing when non-Algolia apps import the shared lib barrel for helpers like cn.
export const SearchClient =
  typeof window === 'undefined' || !hasAlgoliaCredentials
    ? undefined
    : algoliasearch(ALGOLIA_CONFIG.ALGOLIA_APP_ID, ALGOLIA_CONFIG.ALGOLIA_SEARCH_API_KEY);

export const AlgoliaSearchFilterTypes = {
  PRODUCT: ['product', 'structaProductLevel1', 'structaProductLevel2', 'structaProductLevel3', 'productsList'],
  DOCUMENT: ['documentFile'],
  ARTICLE: ['article'],
};
